<template>
  <div v-if="value">
    <img src="../../assets/meter_icon.svg" alt="HYDRAO" />
    <span class="ml gray-text">{{ this.value }}</span>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: "NbMetersRenderer",
  data: () => ({
    value: null
  }),
  mounted() {
    this.value = this.params.value;
  }
});
</script>

<style lang="scss" scoped>
.ml{
  margin-left: 0.5em;
}
</style>